import Amount from "@/models/Shared/Amount";

export default class CreateScheduledFeeRequest {
    overridable: boolean = false;
    enabled: boolean = true;
    name: string = '';
    subTransactionType: string = '';
    reference: string = '';
    periodValue: number = 1;
    periodType: string = '';
    periodOnDayOfWeek: string = undefined;
    periodOnDayOfMonth: string = undefined;
    periodDayOfMonth: number = undefined;
    periodOnMonth: string = undefined;
    amount: Amount = new Amount();
    introductoryPeriodValue: number = 1;
    introductoryAmount: Amount = new Amount();
}